/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_LifestyleInputs */

const en_us2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifestyle`)
};

const pt_br2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de vida`)
};

const es_419_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de vida`)
};

const pt_pt2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de vida`)
};

const fr_fr2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de vie`)
};

const de_de2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensstil`)
};

const it_it2_profile_section_lifestyle = /** @type {(inputs: Profile_Section_LifestyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile di vita`)
};

/**
* | output |
* | --- |
* | "Lifestyle" |
*
* @param {Profile_Section_LifestyleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_lifestyle = /** @type {((inputs?: Profile_Section_LifestyleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_LifestyleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_lifestyle(inputs)
	if (locale === "es-419") return es_419_profile_section_lifestyle(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_lifestyle(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_lifestyle(inputs)
	if (locale === "de-DE") return de_de2_profile_section_lifestyle(inputs)
	if (locale === "it-IT") return it_it2_profile_section_lifestyle(inputs)
	return en_us2_profile_section_lifestyle(inputs)
});
export { profile_section_lifestyle as "profile.section_lifestyle" }